module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z\"/>\n  <path d=\"M0-.5h24v24H0z\" fill=\"none\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/arrow-left.svg
// module id = 777
// module chunks = 1